import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { AuthContextProvider } from 'context/AuthContext';
import App from 'App';

if (!!+process.env.PRODUCTION) {
    ReactGA.initialize(process.env.GOOGLE_ANALYTICS_ID);
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <BrowserRouter>
        <AuthContextProvider>
            <App />
        </AuthContextProvider>
    </BrowserRouter>
);